/* eslint-disable no-param-reassign */
import {
  StateCreator, create,
} from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { MentionOption } from '$/components/InputTextArea/types';
import { INPUT_MEDIA_UPLOAD_COUNT_LIMITS } from '$/utils/mediaUploadLimits';
import {
  TeamAgentState,
} from './types';

/** 创建 Team Agent Store 的默认状态切片。 */
const chatSlice: StateCreator<TeamAgentState, [
  ['zustand/immer', never],
]> = () => ({
  roomTitle: '',
  roomId: '',
  agentList: [],
  showDocumentUpload: false,
  sideBarWidth: 400,
  /** false 表示 Agent 面板展开并占用左侧宽度；true 表示收起后画布占满 */
  sideBarCollapsed: false,
  createChatStatus: 'normal',
  onPaySuccessContinueSSE: null,
  MAX_AGENT_IMAGE_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxImageNum,
  MAX_AGENT_VIDEO_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxVideoNum,
  MAX_AGENT_DOCUMENT_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxDocumentNum,
  MAX_AGENT_TEXT_NUMS: 5000,
});

const useTeamAgentStore = create<TeamAgentState>()(
  immer(
    persist(
      chatSlice,
      {
        name: 'useTeamAgentStore',
        version: 1,
        partialize: (state) => ({ sideBarWidth: state.sideBarWidth }),
      },
    ),
  ),
);
export default useTeamAgentStore;

export function setRoomId(roomId: string) {
  useTeamAgentStore.setState(() => ({ roomId }));
}

/**
 * 设置 Agent 列表
 * @param agentList  Agent 列表
 */
export const setAgentList = (agentList: MentionOption[]) => {
  useTeamAgentStore.setState(() => ({ agentList }));
};

/**
 * 设置房间名称
 */
export const setRoomTitle = (roomTitle: string) => {
  useTeamAgentStore.setState(() => ({ roomTitle }));
};

// 设置上传按钮是否展示
export const setShowDocumentUpload = (showDocumentUpload: boolean) => {
  useTeamAgentStore.setState(() => ({ showDocumentUpload }));
};

/**
 * 设置支付成功后继续 SSE 的回调函数
 *
 * @export
 * @param {TeamAgentState['onPaySuccessContainueSSE']} onPaySuccessContainueSSE 新的回调函数
 */
export function setOnPaySuccessContinueSSE(onPaySuccessContinueSSE: null | (() => void | Promise<unknown>)) {
  useTeamAgentStore.setState((state) => {
    state.onPaySuccessContinueSSE = onPaySuccessContinueSSE;
  });
}

/**
 * 设置 Agent 侧栏折叠状态，供画布视口计算（如 nodesIntoView、双击聚焦）扣除左侧宽度。
 * @param collapsed - true 表示侧栏收起，false 表示展开
 */
export function setSideBarCollapsed(collapsed: boolean) {
  useTeamAgentStore.setState(() => ({ sideBarCollapsed: collapsed }));
}
